import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef, ViewContainerRef, SimpleChanges, OnChanges, AfterViewChecked, AfterViewInit, AfterContentInit, SecurityContext, NgZone, Renderer2 } from '@angular/core';
// import { SessionProvider } from 'ess-plugin-base';
import { SessionProvider, I18N } from 'ess-plugin-base';
// import { Router, ActivatedRoute } from '@angular/router';
// import { Subscription, Observable, of } from 'rxjs';
import { MatSnackBar } from '@angular/material';
// import { Constants } from '../Constants';
// import { MailProvider } from '../../providers/mail.provider';

import { MatChipInputEvent, MatAutocompleteSelectedEvent, MatSelectChange } from '@angular/material';
import { FormControl } from '@angular/forms';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';

// import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import { CacheProvider } from '../cache.provider';
// import { PlatformProvider } from '../platform.provider';
// import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TimeEvent, TimeProvider } from '../time.provider';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { SearchProvider, MatchType } from '../../search.provider';

@Component({
  selector: 'event-form',
  templateUrl: './event.form.html',
  styleUrls: ['./event.form.scss']
})
export class EventForm implements OnInit, OnChanges, OnDestroy {

  @Input('event')
  event: TimeEvent = null;

  original: TimeEvent = null;

  @Input('tagsets')
  tagsets: any;

  tagsCtl = new FormControl();

  resourcesCtl = new FormControl();

  // sentToUsers: any = {}

  // private username: string;
  // private password: string;
  // private isRememberMe: boolean;

  // user: any;
  // user_sub: Subscription;

  // flags: any = {};

  loading: boolean;

  filteredRes: any[] = [];   //Observable<any[]>;

  @ViewChild('resInput', { static: true })
  resInput: ElementRef;

  @Input('canEdit')
  canEdit: boolean = true;

  // @ViewChild('body_embedded', {static: false, read: ViewContainerRef})
  // bodyEmbedded: ViewContainerRef;

  // visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  // all_users: any[] = [
  //   {username: 'ss', full_name: 'Sameh'},
  //   {username: 'hh', full_name: 'Hasna'},
  //   {username: 'rr', full_name: 'Remonda'},
  // ];
  // result_users : any[] ;

  startTime: String;

  endTime: String;

  related: any[] = [];

  //  to_users: any[] = [];

  //  resourcesCtl = new FormControl();

  // public CKEditor = ClassicEditor;

  // public customContent: string;

  // private lastContent: SafeHtml;

  constructor(protected session: SessionProvider, public i18n: I18N,
    // private renderer: Renderer2, private zone: NgZone,
    // private router: Router, private activatedRoute: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private provider: TimeProvider, private search: SearchProvider) { //}, private sanitizer: DomSanitizer, private cacheProvider: CacheProvider) {

    // this.filteredTo = 
    this.resourcesCtl.valueChanges
      .pipe(
        debounceTime(500),
        tap(() => { /*console.log('started');*/ this.loading = null; }),
        switchMap((name: string) => this.search.getResources(name, 10, MatchType.PARTIAL, null)
          .pipe(
            finalize(() => this.loading = false),
          )
        )
      )


      // .pipe(
      //     debounceTime(500),
      //     startWith(null),
      //     map((name: string | null) => this.provider.loadUsers(name))     //this.all_users.slice())
      //   )
      .subscribe((result: any) => { /*console.log(result);*/ this.filteredRes = result; });


    // this.load("sam");

    // this.user_sub = this.session.observeUser().subscribe({
    //   next: (user) => {
    //     this.user = user;
    //     // console.log(this.user);
    //   },
    //   error: (err) => this.user = null
    // });
  }


  ngOnInit() {
    // console.log("init", this.message);

    if (this.event) {
      this.original = new TimeEvent().read(this.event);
      this.readTimes();
      //console.log('Init: ', this.event, this.original);
    }

    if (!this.tagsets) {
      this.provider.getTagsets()
        .then(data => {
          this.tagsets = data;
        })
    }

  }

  ngOnDestroy() {
    // if (this.user_sub) this.user_sub.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.event) {
      this.original = new TimeEvent().read(this.event);
      this.readTimes();
      //console.log('Changes: ', this.event, this.original);
    }

    // if (this.event && this.event.tags) {
    //   for(let key of Object.keys(this.event.tags)) {
    //     if (!Array.isArray(this.event.tags[key])) {
    //         this.event.tags[key] = [ this.event.tags[key] ];
    //     }
    //   }
    // }

    // console.log("changes", changes, this.message);
    // if (changes.message) {
    //     this.loadContent();
    // }
  }

  // ngAfterViewInit() {
  //   console.log("viewInit", this.message);
  //   this.loadContent();
  // }

  // ngAfterContentInit() {
  //   this.loadContent();
  // }

  readTimes() {
    this.startTime = null;
    this.endTime = null;
    if (this.event && !this.event.allday) {
        if (this.event.starts) {
            this.startTime = this.event.starts.getHours() + ':' + this.event.starts.getMinutes(); 
            // this.startTime = new Date(this.event.starts);
        }
        if (this.event.ends) {
            this.endTime = this.event.ends.getHours() + ':' + this.event.ends.getMinutes(); 
            // this.endTime = new Date(this.event.ends);
        }
    }
    // console.log("Times are now", this.event, this.startTime, this.endTime);
  }

  startDateChanged(event: any) {
    // console.log('Start date set to:', event);
    if (event && !event.allday && this.startTime) {
      //this.event.starts = new Date(event);
      this.startTimeChanged('' + this.startTime);
    }
  }

  endDateChanged(event: any) {
    // console.log('End date set to:', event);
    if (event && !event.allday && this.endTime) {
      //this.event.ends = new Date(event);
      this.endTimeChanged('' + this.endTime);
    }
  }

  startTimeChanged(time: string) {
    if (!this.event.starts) {
      this.event.starts = new Date();
    } else {
      this.event.starts = new Date(this.event.starts);
    }
    let all = time.split(' ');
    let parts = all[0].split(':');

    let noon = (all[1].toLowerCase() == 'pm') ? 12 : 0;
    let hrs = +parts[0];
    hrs = (hrs < 12)? hrs + +noon : (hrs % 24);
    let mins = +parts[1];

    this.event.starts.setHours(hrs);
    this.event.starts.setMinutes(mins);

    // console.log("New start time:", this.event.starts);
  }

  endTimeChanged(time: string) {
    if (!this.event.ends) {
      this.event.ends = this.event.starts || new Date();
    } else {
      this.event.ends = new Date(this.event.ends);
    }
    let all = time.split(' ');
    let parts = all[0].split(':');

    let noon = (all[1].toLowerCase() == 'pm') ? 12 : 0;
    let hrs = +parts[0];
    hrs = (hrs < 12)? hrs + +noon : (hrs % 24);
    let mins = +parts[1];

    this.event.ends.setHours(hrs);
    this.event.ends.setMinutes(mins);

    // console.log("New end time:", this.event.ends);
  }

  tagsChanged(tagset: any, e: MatSelectChange) {
    // console.log("Selection for", tagset, e);
    // console.log("Selected", e.value);

    /*    if (Array.isArray(e.value)) {
          let multi: String[] = [];
          e.value.map((tag) => multi.push(tag.code));
          this.event.tags[tagset.code] = multi;
        } else {
          this.event.tags[tagset.code] = e.value.code;
        }
        */
  }

  // loadContent() {
  //   // console.log("Preparing content for ", this.message);
  //   if (this.event && this.event['type']) {
  //     let def = this.platform.getMailDef(this.event);

  //     if (def) setTimeout(() => {

  //       if (def.plugin) {
  //         // console.log(def);
  //         this.platform.loadPlugin(def.plugin);
  //         this.zone.run(() => {
  //           window.location.hash = def.plugin;
  //         })
  //         // history.pushState(null, null, window.location.href.split('#')[0]);
  //       }

  //       // this.customContent = '<' + def.selector + ' id="customContent"></' + def.selector + '>';
  //       let container = document.getElementById('body_embedded');
  //       let content = this.renderer.createElement(def.selector);
  //       this.renderer.appendChild(container, content);
  //       // let content = container.appendChild(document.createElement(def.selector, {}));

  //       // const observer = new MutationObserver((mutations) => {
  //       //   mutations.forEach((mutation) => console.log(mutation));
  //       // });

  //       // observer.observe(container, {
  //       //   attributes: false,
  //       //   childList: true,
  //       //   characterData: false
  //       // });

  //       if (this.event.body) {
  //         // setTimeout(() => {

  //         // if (typeof(this.message.payload === 'object')) {
  //         //   console.log("Setting JSON");
  //         this.renderer.setAttribute(content, 'data', JSON.stringify(this.event.body));
  //         // content.setAttribute('data', JSON.stringify(this.message.payload));
  //         // } else {
  //         //   console.log("Setting raw value");
  //         // content.setAttribute('data', this.message.payload);
  //         // }
  //         // console.log("Loading data into content: ", this.message);
  //         // console.trace();

  //         // }, 100);
  //       }
  //       // this.customContent = this.sanitizer.bypassSecurityTrustHtml(elementHtml);

  //       // console.log("Loading content: ", this.customContent);

  //       // this.lastContent = this.customContent;

  //       /*let path = def.plugin.split('/').concat( def.route.split('/') );
  //       // path.push('' + this.message.outbox_id);
  //       console.log(this.activatedRoute, path, this.router.config);
  //       // this.router.navigate([def.route + '/' + this.message.outbox_id]);

  //       // this.router.navigate([def.route + '/' + this.message.outbox_id], {queryParams: {id: this.message.outbox_id} });
  //       console.log(document.getElementById('inboxBody'));
  //       this.router.navigate([{outlets: {'inboxBody': path } }], {relativeTo: this.activatedRoute.parent });

  //       // this.router.navigate([{outlets: {'inboxBody': '/'+def.plugin+'/'+def.route } }], {relativeTo: this.activatedRoute.parent });

  //       // this.router.navigate(['', {outlets: {'inbox_embedded': path } }],{
  //       //   relativeTo: this.activatedRoute.parent // <--- PARENT activated route.
  //       // });

  //       // this.router.navigate(['/', {outlets: {'inbox_embedded': path } }]);
  //       // this.router.navigate([{outlets: {inbox_embedded: path}}]);
  //         // def.getComponent(this.message, this.bodyEmbedded);
  //         */
  //     }, 100);
  //   }
  // }

  // load(name: string) : any[]{

  //   this.provider.loadUsers(name)
  //   .then(data => {
  //     if (data && data.users) {
  //       this.result_users = data.users;
  //       console.log("all_users: ",this.result_users);
  //       return this.result_users;
  //     } else {
  //       return [];
  //     }
  //   });
  //   return [];
  // }


  relate(event: MatChipInputEvent): void {
    // console.log(event);
    const input = event.input;
    // const value = event.value;

    // if ((value || '').trim()) {
    //   this.to_users.push({username: value.trim()});
    // }

    // this.to_users.push(value);
    // Add our fruit
    // if ((value || '').trim()) {
    //   this.to_users.push({full_name: value.trim()});
    // }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  unrelate(array: any[], res: any): void {
    const index = array.indexOf(res);

    if (index >= 0) {
      array.splice(index, 1);
    }
  }

  /*
    filter(name: string | any): Observable<any[]> {
  
      // If an object, return an array with that object..
      if (name.username || name.full_name) {
        return of([name]);
      }
  
      return this.provider.loadUsers(name);
        // .then(data => {
        //     if (data && data.users) {
        //       return data.users;
        //     }
        // })
      // );
  
  
      // if not, filter users by a string value.. 
      // return this.all_users.filter(user =>
      //     (user.full_name.toLowerCase().indexOf(name.toLowerCase()) >= 0) 
      //     || 
      //     (user.username.toLowerCase().indexOf(name.toLowerCase()) >= 0)
      // )
    }
    */

  selectedRes(event: MatAutocompleteSelectedEvent): void {
    // console.log(event);
    if (event && event.option) {
      let res = event.option.value;
      if (!this.related.includes(res)) {

        this.related.push(event.option.value);   // viewValue
      }
    }

    // this.toUserInput.nativeElement.value = '';
    this.resourcesCtl.setValue(null);
  }

  // enter(event: any) {
  // console.log(event);
  // if (event.code == 'Enter') {
  //   if (event.target.name == 'password') {
  //     this.doLogin();
  //   }
  // }
  // }

  doSave() {

    if (!this.event.starts && !this.event.name || this.event.name.length == 0) {
      this._snackBar.open("please enter a name and start date.", " ", {
        duration: 6000,
      });
      // alert..
      return;
    }
    /*
        if (!this.related || this.related.length == 0) {
          this._snackBar.open("please select related resources.", " ", {
            duration: 5000,
          });
          // alert..
          return;
        }
    */
    // this.message.action = 'inbox';
    // this.message.type = 'mail';
    // this.message.sender = SessionProvider.user.username;

    // this.message.to = [];
    // for(let user of this.to_users) {
    //   this.message.to.push(user.username);
    // }

    this.loading = true;

    // let url = Constants.protocol + Constants.identityServer + '/mail';

    this.provider.saveEvent(this.event)
      .then(ok => {
        if (ok) {
          //console.log('Saving', this.event);

          this.original = new TimeEvent().read(this.event);
          // this.session.loadPermissions('http://' + Constants.identityServer + '/permission/list')
          //   .then(done => {
          //     if (done) {
          //       //console.log(SessionProvider.user);
          //       this.ws.stayAlive();
          //     } else {
          if (ok && ok.id) {
            this._snackBar.open("Event saved successfully.", " ", { duration: 6000 });
          } else {
            this._snackBar.open("Invalid event. Please revise your data and try again later.", " ", { duration: 6000 });
          }
          //     }
          this.loading = null;
          //   })
        } else {
          this._snackBar.open("Could not save. Please check your connection and credentials and try again later.", " ", { duration: 6000 });
          this.loading = null;
        }
      })
      .catch(err => {
        this.loading = null;
        this._snackBar.open("Could not save. Please check your connection and credentials and try again later.", " ", { duration: 6000 });
      })
  }

  doCancel() {
    if (this.original && this.event) {
      // console.log('Going back from ', this.event, this.original);
      this.event.read(this.original);
      this.readTimes();
    }

    // if (!this.original.starts && !this.original.name || this.original.name.length == 0) {
    //   this._snackBar.open("please enter a name and start date.", " ", {
    //     duration: 5000,
    //   });

    //   return;
    // }
    // this.loading = true;


    // this.provider.saveEvent(this.original)
    //   .then(ok => {
    //     if (ok) {

    //       if (ok && ok.id) {
    //         this._snackBar.open("Event saved successfully.", " ", { duration: 5000 });
    //       } else {
    //         this._snackBar.open("Invalid event. Please revise your data and try again later.", " ", { duration: 5000 });
    //       }
    //       //     }
    //       this.loading = null;
    //       //   })
    //     } else {
    //       this._snackBar.open("Could not save. Please check your connection and credentials and try again later.", " ", { duration: 5000 });
    //       this.loading = null;
    //     }
    //   })
    //   .catch(err => {
    //     this.loading = null;
    //     this._snackBar.open("Could not save. Please check your connection and credentials and try again later.", " ", { duration: 5000 });
    //   })
  }

}

